import { Spinner } from '../../../../components/Spinner'
import { RequestForm } from './RequetForm'

import { handlerType } from '../../../../enumns/handlerType'
import { useRequestQuery } from '../../../../services/hooks/request/queries/useRequestsQuery'

type Props = {
  onClose: () => void
  id?: number
}

export const EditForm = ({ onClose, id }: Props) => {
  const { data } = useRequestQuery(id || null)

  return (
    <>
      {!data ? (
        <div className="flex items-center justify-center p-5">
          <Spinner />
        </div>
      ) : (
        <div>
          <RequestForm
            defaultValue={data}
            type={handlerType.EDIT}
            onClose={onClose}
            id={id}
          />
        </div>
      )}
    </>
  )
}
